import React from 'react';

/**
 * Metric card component for displaying sensor values
 */
export const MetricCard = ({
  icon,
  label,
  value,
  unit,
  type,
  trend,
  className = '',
  valueStatus
}) => {
  const getTrendIcon = () => {
    if (Math.abs(trend) < 0.01) return { icon: '→', class: 'neutral' };
    return trend > 0 ? { icon: '↑', class: 'up' } : { icon: '↓', class: 'down' };
  };

  const trendInfo = getTrendIcon();

  // Formato de valor según el tipo
  const formatValue = (val) => {
    if (val === null || val === undefined) return '--';
    if (type === 'oxygen') return val.toFixed(2);
    return val.toFixed(1);
  };

  return (
    <div className={`metric-card ${type} ${className}`}>
      <div className="metric-header">
        <div className="metric-icon-wrapper">{icon}</div>
        {trend !== undefined && (
          <div className={`metric-trend ${trendInfo.class}`}>
            <span className="trend-icon">{trendInfo.icon}</span>
            <span className="trend-value">{Math.abs(trend).toFixed(2)}</span>
          </div>
        )}
      </div>
      <div className="metric-label">{label}</div>
      <div className={`metric-value ${valueStatus || ''}`}>
        {formatValue(value)}
        <span className="metric-unit"> {unit}</span>
      </div>
    </div>
  );
};
